import { render, staticRenderFns } from "./Score.vue?vue&type=template&id=6b838c34"
import script from "./Score.vue?vue&type=script&lang=ts"
export * from "./Score.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports